import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ScheduleService {

  constructor(private api: ApiService) { }

  getDepartments(data:any): Observable<any> {
    return this.api.post(environment.getAllDepartment,data);
  }

  getUsersByDepartments(data:any): Observable<any> {
    return this.api.post(environment.getUserByDepartment,data);
  }
  getAllSchedule(data:any): Observable<any> {
    return this.api.post(environment.getAllSchedule,data);
  }

  createSchedule(data:any): Observable<any> {
    return this.api.post(environment.createSchedule,data);
  }
  bulkSchedule(data:any): Observable<any> {
    return this.api.post(environment.bulkSchedule,data);
  }

  deleteSchedule(id:any): Observable<any> {
    return this.api.delete(environment.deleteSchedule+"/"+id);
  }
  

}


